<script>
    import { onMount, createEventDispatcher } from 'svelte';
    import {Button, Modal, ModalBody, ModalFooter, ModalHeader, CustomInput } from 'sveltestrap';
    import  http  from "../api/http.js";
    import { selectedGroup } from '../store';
    let shown =false;
    const dispatch = createEventDispatcher();
    const toggle = () => (shown = !shown);
    let version;
   
    export async function show(versionArg) {
        version = versionArg;
        shown = true;
    }

    async function deleteVersion() {
        const res = await http.delete(window.apiBaseUrl + `/deploy/dashboard/software/version/${version.id}/${$selectedGroup}`);
        if (res.status == 200) {
            dispatch('versionDeleted');        
            shown = false;
        }
    }
   
    function _onYes() {  
       deleteVersion();
    }    
       
    function _onNo() {
        shown = false;
    }
   </script>
  
   <Modal isOpen={shown} {toggle}>
       <ModalHeader {toggle}>
           Delete Version
       </ModalHeader>
       <ModalBody>
           <p>Are you sure you want to delete <strong class="text-info">{version.versionNumber}</strong>?</p>
           <p class="text-danger"><i class="fa fa-exclamation-triangle"></i> This action is <strong>Permanent</strong> and cannot be undone are you sure you wish to continue?</p> 
       </ModalBody>
       <ModalFooter>
            <button id="delete-version-cancel-button" class="btn btn-outline-primary" on:click={() => _onNo()}>Cancel</button>
           <button id="delete-version-confirm-button" on:click={() => _onYes()} class="btn btn-primary">Confirm</button>
       </ModalFooter>
   </Modal>

<style>

</style>